/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import { shouldStartRendering, getTotalPages } from "selectors/documentSelectors";
import { zoomOutHandler } from "services/NavigationBarService";
import { isMinZoomReached } from "selectors/zoom";
import * as constants from "constants/constants";
import ZoomOutIconOld from "dc-icons/consumption/s_zoom_out_hud_18.svg";
import ZoomOutIconModern from "dc-icons/viewer2021/SDC_ZoomOut_18_N_1.svg";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import { withKeyboardShortcutLabel } from "components/hocs/withKeyboardShortcutLabel";

const mapStoreToProps = (stores, ownProps) => {
  const useModernViewer = getShouldUseModernViewer(stores);
  const props = {
    useModernViewer: getShouldUseModernViewer(stores),
    icon: useModernViewer ? ZoomOutIconModern : ZoomOutIconOld,
    clickHandler: zoomOutHandler,
    className: ownProps.className || "",
    ariaLabel: useModernViewer ? "modernviewer.arialabel.zoomOut" : "arialabel.zoomOut",
    tooltipString: useModernViewer ? "modernviewer.tooltip.zoomOut" : "tooltip.zoomOut",
    tooltipPlacement: useModernViewer ? constants.TOOLTIP_LEFT_PLACEMENT : constants.TOOLTIP_TOP_PLACEMENT,
    tooltipDelay: constants.TOOLTIP_DELAY,
    shouldDisable: getShouldUseModernViewer(stores)
      ? !shouldStartRendering(stores) || isMinZoomReached(stores) || getTotalPages(stores) === 0
      : !shouldStartRendering(stores)
  };
  return props;
};

const ZoomOutContainer = inject(mapStoreToProps)(
  withKeyboardShortcutLabel(constants.KEYBOARD_SHORTCUTS.ZOOM_OUT, ButtonWrapper)
);

export { ZoomOutContainer };
